<template>
    <div>
        <Row :gutter="10" type="flex" justify="start">
            <Col :span="6"><RadioGroup v-model="searchForm.timeType" type="button" button-style="solid" style="width: 100%;display:flex;padding:0">
                <Radio label="day" style="width:calc(100% / 3);text-align: center;">日报</Radio>
                <Radio label="week" style="width:calc(100% / 3);text-align: center;">周报</Radio>
                <Radio label="month" style="width:calc(100% / 3);text-align: center;">月报</Radio>
            </RadioGroup></Col>
            <Col :span="3">
                <Poptip content="筛选设备时不支持自定义时区，数据按广告账户时区进行统计" transfer trigger="hover" style="width: 100%;" :disabled="!(!!searchForm.deviceSys||searchForm.deviceSys===0)">
                    <Select transfer v-model="searchForm.timezoneOffset"
                        placeholder="时区偏移量" filterable @on-change="$event||$event===0?searchForm.deviceSys='':''" :disabled="!!searchForm.deviceSys||searchForm.deviceSys===0">
                        <Option :value="-8" label="美国时间">美国时间(西八区 UTC-8)</Option>
                        <Option :value="0" label="世界标准时间">世界标准时间(UTC+0)</Option>
                        <Option :value="8" label="北京时间">北京时间(东八区 UTC+8)</Option>
                    </Select>
                </Poptip>
            </Col>
            <Col :span="4">
            <DatePicker :editable="false" transfer format="yyyy-MM-dd" type="daterange" style="width: 100%;" :options="options"
                placeholder="请选择日期" :value="listDate" @on-change="getListDate" :clearable="false"></DatePicker>
            </Col>
            <Col :span="4">
            <Select transfer placeholder="推广渠道" clearable v-model="searchForm.channel">
                <Option :value="-1">全部</Option>
                <Option :value="0">facebook</Option>
                <Option :value="1">tiktok</Option>
                <Option :value="2">google</Option>
            </Select>
            </Col>
            <Col :span="4">
                <Poptip content="出于平台接口限制，当筛选设备时，数据将按广告账户时区进行统计" transfer trigger="hover" style="width: 100%">
                    <Select transfer placeholder="操作设备" clearable v-model="searchForm.deviceSys" @on-change="$event||$event===0?searchForm.timezoneOffset='':''" @on-clear="searchForm.timezoneOffset=-8">
                        <Option :value="-1">全部</Option>
                        <Option :value="0">iOS</Option>
                        <Option :value="1">Android</Option>
                        <Option :value="2">其他</Option>
                    </Select>
                </Poptip>
            </Col>
            <Col :span="3">
            <Select v-model="searchForm.langCns" transfer placeholder="请选择语言" clearable multiple filterable :max-tag-count="1">
                      <Option v-for="(item,index) in langList" :key="index" :value="item.chineseLangName">{{ item.chineseLangName }}</Option>
                </Select>
            </Col>
            <Col :span="6" style="margin-top: 10px;">
                <playCascader :value="searchForm.playIds" @update:value="searchForm.playIds = $event" ref="playCnRef" />
            </Col>
            <Col :span="4" style="margin-top: 10px;">
                <Select transfer placeholder="输入短剧id" v-model="searchForm.playIds1" ref="playRef" :remote-method="handleGetPlay" clearable multiple filterable :max-tag-count="1">
                    <template #prefix>
                        <a v-show="searchForm.playIds1.length" style="font-size: 12px;padding: 0 5px;white-space:nowrap"
                            @click="(e) => {
                                e.preventDefault()
                                e.stopPropagation();
                                searchForm.playIds1 = []
                            }">清空</a>
                    </template>
                    <Option v-for="(item, index) in playList" :key="index" :value="item.playId"
                        style="width: 300px;overflow:hidden;display:flex">
                        {{ item.playId }} - {{ item.playName }}
                        
                        
                    </Option>
                </Select>
            </Col>
            <Col :span="3" style="margin-top: 10px;">
            <Select transfer  v-model="searchForm.personIds"
                placeholder="请选择优化师" filterable :max-tag-count="1" multiple>
                <template #prefix>
                    <a v-show="searchForm.personIds.length" style="font-size: 12px;padding: 0 5px;white-space:nowrap"
                        @click="(e) => {
                            e.preventDefault()
                            e.stopPropagation();
                            searchForm.personIds = []
                        }">清空</a>
                </template>
                <Option v-for="(i, index) in searchOptions.person" :key="index" :value="i.id">{{ i.dictName }}
                </Option>
            </Select>
            </Col>
            <Col :span="1" style="margin-top: 10px;"><Button type="primary" @click="handleSearchData">搜索</Button>
            <!-- <Button style="margin: 0 0 0 10px" @click="handleReset">重置</Button> -->
            </Col>
                <div style="flex-grow: 1;text-align: right;margin-top: 10px;padding-right: 12px;padding: 0 5px">
                    <Tooltip transfer content="点击下载">
                    <Button style="padding:4px 5px" :loading="exportLoading"
                        @click="handleExport">
                        <Icon type="md-download" :size="20" />
                    </Button>
                </Tooltip>
                <Tooltip transfer content="自定义列">
                    <Button style="margin-left: 10px;padding:4px 5px" @click="visible = true">
                        <Icon type="md-options" :size="20" />
                    </Button>
                </Tooltip>
                </div>
            </Row>
        <div style="display: flex;flex-wrap: wrap;">
            
            <div style="flex-grow: 1;text-align: right;margin-top: 10px;">
                
                    <Modal v-model="visible" :width="1000" title="自定义字段编辑" footer-hide>
            <fieldSelector  v-model="column" :orgin="newColumn" @upload:visible="visible=false" @upload:column="submitColumn"  />
        </Modal>
            </div>
        </div>
        <Tables ref="tableRef" style="margin-top: 20px;" :column="columns" :func="getPlayStatOptimizerData" :search-form="{
            ...searchForm,
                channel: searchForm.channel<0?null:searchForm.channel,
            playIds: [...searchForm.playIds,...searchForm.playIds1]
        }" />
    </div>
</template>

<script>
import dayjs from 'dayjs'
import { getPlayList } from '@/api/play'
import { debounce } from 'lodash'
import { columnData } from '../index'
import { getPlayStatOptimizerData, exportPlayStatOptimizerData, getPlay } from '@/api/data'
import draggable from 'vuedraggable';
import playCascader from '../playCascader.vue'
import Tables from '../Table.vue';
import { cloneDeep } from 'lodash'
import fieldSelector from '../../../../../components/fieldSelector/index.vue'
export default {
    name: 'Pitcher',
    components: {
        draggable,
        Tables,
        fieldSelector,
        playCascader
    },
    props: {
        searchOptions: {
            type: Object,
            default: () => ({
                person: [],
                campaign: []
            })
        },
        langList: {
            type: Array,
            default: ()=>([])
        }
    },
    inject: ['parent'],
    watch: {
        visible(){
            this.column = this.columns.map(i=>i.key)
        }
    },
    data() {
        return {
            options: {
                parentLangPlay: {},
                    shortcuts: [
                        {
                            text: '今日',
                            value () {
                                return [dayjs().add(-16, 'hour').toDate(), dayjs().add(-16, 'hour').toDate()];
                            }
                        },
                        {
                            text: '近三天',
                            value () {
                                return [dayjs().add(-16, 'hour').add(-2,'day').toDate(), dayjs().add(-16, 'hour').toDate()];
                            }
                        },
                        {
                            text: '近七天',
                            value () {
                                return [dayjs().add(-16, 'hour').add(-6,'day').toDate(), dayjs().add(-16, 'hour').toDate()];
                            }
                        },
                        {
                            text: '近一个月',
                            value () {
                                return [dayjs().add(-16, 'hour').add(-1,'month').toDate(), dayjs().add(-16, 'hour').toDate()];
                            }
                        }
                    ],},
            getPlayStatOptimizerData,
            keyword: '',
            visible: false,
            exportLoading: false,
            searchForm: {
                timeType: 'day',
                personIds: [],
                playIds1: [],
                timezoneOffset: -8,
                playIds: [],
            },
            columnData,
            newColumn: [],
            column: [],
            columns: [],
            playLoading: false,
            listDate: [],
            playList: []
        }
    },
    methods: {
        handleSearchData(){
            this.$refs.tableRef.handleGetData()
        },
        submitColumn() {
            this.columns = this.column.map(i => {

                const obj = this.newColumn.find(j => j.key == i)

                return {
                    title: obj.title,
                    key: obj.key,
                    unit: obj.unit,
                    index: obj.index,
                    fixed: obj.fixed,
                    width: obj.width ? obj.width : (obj.title.length > 5 ? 140 : 100),
                    notFixed: obj.notFixed,
                    needCalc: obj.needCalc,
                    tooltip: !!obj.tooltip,
                    tooltipMaxWidth: obj.tooltipMaxWidth,
                    slot: obj.slot,
                    resizable: true,
                    calc: obj.calc,
                    sortable: !obj.sortable ? false : 'custom',
                    render: obj.render
                }
            })
            this.visible = false
            localStorage.setItem('play-pitcher', JSON.stringify(this.columns))

        },
        handleGetPlay: debounce(function (query) {
            if (!query) {
                this.playList = []
                this.playLoading = false
            } else {
                this.playLoading = true
                getPlay({
                    current: 1,
                    name: query,
                    size: 10000
                }).then(r => {
                    this.playList = r.data.records
                    this.playLoading = false
                })
            }
        }, 700),
        getListDate(data) {
            this.listDate = data
            this.searchForm.startDate = data[0]
            this.searchForm.endDate = data[1]
            this.parent.searchDate = data
        },
        handleReset() {
            this.searchForm = {
                personIds: [],
                playIds: [],
                playIds1: [],
                timezoneOffset: -8,
                timeType: 'day'
            }
                this.getListDate([dayjs().add(-16, 'hour').format('YYYY-MM-DD'), dayjs().add(-16, 'hour').format('YYYY-MM-DD')])
            
        },
        handleSelectAll() {
            this.column = [...this.column, ...this.newColumn.filter(i => !this.column.includes(i.key)).map(i => i.key)]
        },
        handleResetColumn() {
            this.column = this.newColumn.filter(i => i.always.includes('pitcher')).map(i => i.key)
        },
        handleExport() {
            this.exportLoading = true
            exportPlayStatOptimizerData({
                ...this.searchForm,
                deviceSys: this.searchForm.deviceSys<0?null:this.searchForm.deviceSys,
                channel: this.searchForm.channel<0?null:this.searchForm.channel,
                playIds: [...this.searchForm.playIds,...this.searchForm.playIds1]
            }).then(r=>{
                const link = document.createElement('a')
                link.style.display = 'none'
                link.href = r.data.fileUrl
                // link.href = window.location.origin + r.data.fileUrl.substring(r.data.fileUrl.indexOf('/s_excel'), r.data.fileUrl.length)
                link.setAttribute('download', r.data.fileName)
                document.body.appendChild(link)
                link.click()
                document.body.removeChild(link)
                this.exportLoading = false
            }).catch(e=>{
                this.exportLoading = false
            })
        },
    },
    async mounted() {
        this.newColumn = cloneDeep(this.columnData.filter(i=>!i.only||i.only.includes('pitcher')).map(i=>({
            ...i,
            always: i.always&&i.always.includes('pitcher')
        })))
        
        this.newColumn[1].always = 'pitcher'
        this.newColumn[1].fixed = 'left'
        const column = localStorage.getItem('play-pitcher')
        if (column) {
            this.column = JSON.parse(column).map(i => i.key)
        }else{
            this.column = [...this.newColumn].map(i=>i.key)
        }
        const date = this.parent.searchDate
        this.handleReset()
        if (date && date.length) {
            // this.searchForm.startDate = JSON.parse(date)[0]
            // this.searchForm.endDate = JSON.parse(date)[1]
            this.getListDate([date[0], date[1]])
        }
        this.submitColumn()
        if(Object.keys(this.parent.extraData).length){
            if(this.parent.extraData.playCnName){
                this.parentLangPlay = {playCnName: this.parent.extraData.playCnName}
            }
            console.log(this.$refs.playCnRef.$refs.selectRef.values = []);
            
            if(this.parent.extraData.playIds)
            this.$refs.playCnRef.treeValue = this.parent.extraData.playIds
            if(this.parentLangPlay.playCnName) {
                await this.$refs.playCnRef.handleGetPlay(this.parent.extraData.playCnName)
            }
            
            this.searchForm = {
                ...this.searchForm,
                ...this.parent.extraData
            }
            
            this.parent.extraData = {}
        }
        this.$nextTick(()=>{
            this.handleSearchData()
            const scroll = document.querySelector(".ivu-table-body");
                const fixed = document.querySelector(".ivu-table-fixed-body");
                
                // 监听滚轮
                scroll &&
                    scroll.addEventListener(
                    "mousewheel",
                    (e) => {
                        if (scroll.scrollLeft <= 0 && e.deltaX < 0) {
                            e.preventDefault();
                        }
                    },
                    {
                        passive: false,
                    }
                    );
                fixed &&
                    fixed.addEventListener("wheel", (e) => {
        if(e.deltaX)e.preventDefault();

                    e.preventDefault();
                    });
        })
        
    },
    async activated(){
        this.handleGetPlay()
        const date = this.parent.searchDate
        if (date && date) {
            // this.searchForm.startDate = JSON.parse(date)[0]
            // this.searchForm.endDate = JSON.parse(date)[1]
            this.getListDate([date[0], date[1]])
        }
        if(Object.keys(this.parent.extraData).length){
            if(this.parent.extraData.playCnName){
                this.parentLangPlay = {playCnName: this.parent.extraData.playCnName}
            }
            
                // this.$refs.playCnRef.$refs.selectRef.values = []
            this.$refs.playCnRef.data = []
            if(this.parent.extraData.playIds)
            this.$refs.playCnRef.treeValue = this.parent.extraData.playIds
            if(this.parentLangPlay.playCnName) {
                await this.$refs.playCnRef.handleGetPlay(this.parent.extraData.playCnName,true)
            }
            
            this.searchForm = {
                ...this.searchForm,
                ...this.parent.extraData
            }
            
            this.parent.extraData = {}
            this.$nextTick(()=>{
                this.handleSearchData()
            })
        }
        
    }
}
</script>

<style lang="less" scoped>
.checkbox {
    margin: 0 -10px;
    overflow: hidden;
    width: 100%;
    &>* {
        width: 50%;
        flex: 0 50%;
        padding: 5px 10px;
        font-size: 16px;
    }
}
/deep/.ivu-checkbox{
    margin-right: 10px;
}
/deep/.ivu-poptip-rel{
    width: 100%
}
</style>